import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: [0, theme.spacing(3), theme.spacing(3)],
    [theme.breakpoints.up('mobile')]: {
      maxWidth: 500,
      minWidth: 400,
    },
  },
  field: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  visibilityIcon: {
    fill: theme.palette.colors.teal,
    cursor: 'pointer',
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(5),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/ForgotPasswordForm/useStyles.js